export const getUserString = (user) => `${user.first_name}${user.last_name ? ` ${user.last_name}` : ''}`
